import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('intexso_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith('/admin') && !window.location.pathname.endsWith('/admin')) {
      localStorage.removeItem('intexso_admin_token');
      window.location.href = '/admin';
    }
    return Promise.reject(err);
  }
);

// Resolve CMS asset URLs ("/api/uploads/x.jpg") against backend origin
export const assetUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('data:')) return path;
  return `${BACKEND_URL}${path}`;
};
